// ============================================================
// src/components/admin/AdminLogin.js
// ✅ Allows BOTH hospital admin + doctors of THAT hospital
// ✅ Blocks doctors from other hospitals
// ============================================================
import React, { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import api from "../../utils/api";

export default function AdminLogin({ showToast }) {
  const { login, hospitalId, hospitalSlug } = useAuth();
  const [doctorId, setDoctorId] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    if (!doctorId.trim() || !password) {
      setError("Please enter Doctor ID and password.");
      return;
    }
    setLoading(true);
    setError("");
    try {
      const res = await api.post("/auth/login", {
        doctorId: doctorId.trim(),
        password,
      });

      const doctorHospitalId = res.doctor?.hospitalId;

      if (hospitalId) {
        // ── Hospital page (Sai Dental, City Ortho etc.) ──────
        // Allow: doctor whose hospitalId matches THIS hospital
        // Allow: hospital admin (isAdmin) whose hospitalId matches
        // Block: doctors from other hospitals
        // Block: PearlSmile doctors (hospitalId: null)

        if (!doctorHospitalId) {
          // null hospitalId = PearlSmile doctor trying Sai Dental
          setError("Access denied. You are not registered with this hospital.");
          setPassword("");
          setLoading(false);
          return;
        }

        if (doctorHospitalId.toString() !== hospitalId.toString()) {
          // Different hospital
          setError(
            "Access denied. This account does not belong to this hospital.",
          );
          setPassword("");
          setLoading(false);
          return;
        }

        // ✅ Same hospital — allow login
      } else {
        // ── PearlSmile root page ──────────────────────────────
        // Allow: doctors with hospitalId: null (PearlSmile doctors)
        // Block: doctors from any registered hospital

        if (doctorHospitalId) {
          setError(
            "Access denied. Please login from your hospital's page on VidyaOne.",
          );
          setPassword("");
          setLoading(false);
          return;
        }

        // ✅ PearlSmile doctor — allow login
      }

      // ✅ Login successful
      login(res.token, res.doctor);
      showToast?.("✅ Logged in as " + res.doctor.name);
    } catch (err) {
      setError(err.message || "Incorrect credentials. Please try again.");
      setPassword("");
    }
    setLoading(false);
  };

  return (
    <div className="admin-login-gate">
      <div className="admin-lock-icon">🔒</div>
      <h2>Doctor Admin Panel</h2>
      <p>
        This area is restricted to authorised medical staff only. Please enter
        your credentials to continue.
      </p>
      <div className="admin-login-form">
        <div className="admin-input-group">
          <label>Doctor ID</label>
          <input
            type="text"
            placeholder="Enter your Doctor ID"
            value={doctorId}
            onChange={(e) => setDoctorId(e.target.value)}
            autoComplete="off"
          />
        </div>
        <div className="admin-input-group">
          <label>Password</label>
          <input
            type="password"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleLogin()}
          />
        </div>
        <button
          className="admin-login-btn"
          onClick={handleLogin}
          disabled={loading}
        >
          {loading ? "Authenticating..." : "Access Admin Panel →"}
        </button>
        {error && <div className="admin-err">{error}</div>}
      </div>
    </div>
  );
}
